const translations = {
  page_title: 'Deals Reports',
  deals_by_make: 'Deals by Make',
  deals_by_models: 'Deals by Models',
  deals_by_transaction_type: 'Deals by Transaction Type',
  deals_by_financial_institution: 'Deals by Financial Institution',
  deals_by_products: 'Deals by Products',
  deals_by_towns: 'Deals by Towns',
  deals_by_buyer_age: 'Deals by Buyer Age',
  deals_by_day: 'Deals by Day',
  deals_by_seller: 'Deals by Seller',
  total_deals: 'Total Deals',
  change_percent: 'Change %',
  no_data: 'No data available',
  category: 'Category',
  count: 'Count',
};

export default translations;
